import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { assignEmployeestoShift } from "../../actions/shiftActions";
import {
  getCompanies,
  getCompanyEmployees,
} from "../../actions/companyActions";
import { getCompaniesOfEmployee } from "../../actions/employeeActions";
import Form from "./Form";
import { Grid, InputLabel, Select, MenuItem } from "@material-ui/core";

let credentials = JSON.parse(localStorage.getItem("credentials"));

class AssignEmployeesToShiftForm extends Component {
  state = {
    company: "",
    employees: [],

    optionCompanies: [],
    optionEmployees: [],
  };

  componentDidMount() {
    switch (credentials.user.type) {
      case "PERSON":
        this.props.getCompanies().then((optionCompanies) => {
          this.setState({ optionCompanies });
        });

        break;

      case "COMPANY":
        this.props
          .getCompanyEmployees(credentials.user.email)
          .then((optionEmployees) => {
            this.setState({
              optionEmployees: optionEmployees.filter((x) => x.isActive),
            });
          });

        break;

      case "EMPLOYEE":
        if (credentials.user.isSeniorEmployee) {
          this.props
            .getCompaniesOfEmployee(credentials.user.email, true)
            .then((optionCompanies) => {
              this.setState({ optionCompanies });
            });
        }

        break;
    }
  }

  AssignEmployees = (e) => {
    e.preventDefault();

    this.props
      .assignEmployeestoShift(this.props.shiftId, {
        employees: this.state.employees,
      })
      .then(() => window.location.reload());
  };

  handleEmployeeChange = (e) => this.setState({ employees: e.target.value });

  handleCompanyChange = (e) => {
    this.setState({ company: e.target.value, employees: [] });

    this.props.getCompanyEmployees(e.target.value).then((optionEmployees) => {
      this.setState({
        optionEmployees: optionEmployees.filter((x) => x.isActive),
      });
    });
  };

  render() {
    return (
      <Form
        onSubmit={this.AssignEmployees}
        submitText="Inplannen"
        isFetching={this.props.isFetching}
        successMessage={this.props.successMessage}
        errorMessage={this.props.errorMessage}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            {credentials.user.type != "COMPANY" && (
              <Fragment>
                <InputLabel htmlFor="company">Bedrijf *</InputLabel>
                <Select
                  id="company"
                  name="company"
                  value={this.state.company}
                  onChange={this.handleCompanyChange}
                  fullWidth
                >
                  {this.state.optionCompanies.map((company) => (
                    <MenuItem
                      key={company.email}
                      value={company.email}
                      style={{
                        fontWeight:
                          this.state.company != company.email
                            ? "normal"
                            : "500",
                      }}
                    >
                      {company.name}
                    </MenuItem>
                  ))}
                </Select>
              </Fragment>
            )}
          </Grid>

          <Grid item xs={12} sm={credentials.user.type == "COMPANY" ? 12 : 6}>
            <InputLabel htmlFor="employees">Medewerkers *</InputLabel>
            <Select
              id="employees"
              name="employees"
              multiple
              value={this.state.employees}
              onChange={this.handleEmployeeChange}
              fullWidth
            >
              {this.state.optionEmployees.map((employee) => (
                <MenuItem
                  key={employee.companies[0].id}
                  value={employee.companies[0].id}
                  style={{
                    fontWeight:
                      this.state.employees.indexOf(employee.email) === -1
                        ? "normal"
                        : "500",
                  }}
                >
                  {employee.firstName} {employee.lastName} ({employee.email})
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>
      </Form>
    );
  }
}

AssignEmployeesToShiftForm.propTypes = {
  shiftId: PropTypes.string.isRequired,
  assignEmployeestoShift: PropTypes.func.isRequired,
  getCompanies: PropTypes.func.isRequired,
  getCompaniesOfEmployee: PropTypes.func.isRequired,
  getCompanyEmployees: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.arrayOf(PropTypes.string),
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  successMessage: state.shift.assignEmployees.successMessage,
  errorMessage: state.shift.assignEmployees.errorMessage,
  isFetching:
    state.shift.assignEmployees.isFetching ||
    state.company.getCompanies.isFetching ||
    state.company.getCompanyEmployees.isFetching ||
    state.employee.getCompaniesOfEmployee.isFetching,
});

export default connect(mapStateToProps, {
  assignEmployeestoShift,
  getCompanies,
  getCompanyEmployees,
  getCompaniesOfEmployee,
})(AssignEmployeesToShiftForm);



// WEBPACK FOOTER //
// ./src/components/forms/AssignEmployeesToShiftForm.js